import React from 'react';
import { FaPencilAlt as PencilIcon } from 'react-icons/fa';
import { connect } from 'react-redux';

import CustomNumeral from '../../../shared/customNumeral.component';
import { NumeralTypes } from '../../../shared/numeral.component';

import { negativePercentage } from '../utils/numeral.utils';
import {
  checkHasRightsToModifyCTTSelector,
} from '../store/selectors';
import EffectiveTaxRateDetailLink from '../effectiveTaxRateDetailLink.component';

import { CttGroupRendererPropTypes } from './proptypes';
import GroupingColumns from '../GroupingColumns.component';

const CTTGroupRenderer = ({
  rowData,
  ibtAmount,
  toggle,
  suppressHidingDecimalPlacesForPercentage,
  hideGroupingColumns,
  displayGroupingColumnsByPercentages,
  hasRightsToModifyCTT,
  tagName,
  account,
}) => (
  <div className="row child-row expandable ctt">
    <div className="etr-icon-wrapper stick-left">
      {hasRightsToModifyCTT
          && <PencilIcon size={16} className="cell-icon pencil-icon" onClick={toggle} />
      }
    </div>
    <div className="col-6 description stick-left">{rowData.countryTaxTypeDescription}</div>
    <div className="col-2 text-right">
      <EffectiveTaxRateDetailLink
        tagName={tagName}
        account={account}
        countryTaxType={rowData.countryTaxTypeDescription}
        ibtAmount={ibtAmount}
      >
        <CustomNumeral type={NumeralTypes.DECIMAL}>{rowData.amount}</CustomNumeral>
      </EffectiveTaxRateDetailLink>
    </div>
    <div className="col-2 text-right">
      <CustomNumeral
        additionalClassNames={negativePercentage}
        type={NumeralTypes.PERCENT_4}
        suppressHidingDecimalPlaces={suppressHidingDecimalPlacesForPercentage}
      >
        {(rowData.amount / ibtAmount)}
      </CustomNumeral>
    </div>
    <GroupingColumns
      hideGroupingColumns={hideGroupingColumns}
      columnsData={rowData.columnsData}
      sumForPercentagesCalculation={displayGroupingColumnsByPercentages ? ibtAmount : null}
      suppressHidingDecimalPlacesForPercentage={suppressHidingDecimalPlacesForPercentage}
      tagName={tagName}
      account={account}
      countryTaxType={rowData.countryTaxTypeDescription}
      ibtAmount={ibtAmount}
    />
  </div>
);

CTTGroupRenderer.propTypes = CttGroupRendererPropTypes;

const mapStateToProps = (state, ownProps) => ({
  hasRightsToModifyCTT: checkHasRightsToModifyCTTSelector(state, ownProps.rowData.subrows),
});

export default connect(mapStateToProps)(CTTGroupRenderer);
